import "./index.scss";
import { Poly } from "components/Poly";
import { PolyAnchor } from "components/Anchor/utils";
import React from "react";

type Props = {
  label: string;
  description?: string;
  anchorProps: PolyAnchor;
  icon?: string | null;
  alt?: string | null;
  onBlur?: VoidFunction;
};

const HeaderMenuItem = ({
  label,
  description,
  anchorProps,
  icon,
  alt,
  onBlur,
}: Props) => (
  <Poly onBlur={onBlur} {...anchorProps} className="header-menu-item">
    {icon && alt && (
      <img className="header-menu-item__icon" src={icon} alt={alt} />
    )}
    <div className="header-menu-item__text-content">
      <div className="header-menu-item__label">{label}</div>
      {description && (
        <div className="header-menu-item__description">{description}</div>
      )}
    </div>
  </Poly>
);

export default HeaderMenuItem;
